import DELIVERY from '../fragments/delivery';

const IMG = '/images/health';

const page = {
  slug: 'celiac-disease-meal-prep',
  title: 'Celiac Disease Meal Prep',
  hero: {
    title: 'Celiac Disease Meal Prep',
    subtitle: '🤝 Trusted by Registered Dietitians, Nutritionists, Endocrinologists, Fitness Trainers, Health Coaches and more',
    image: `${IMG}/condition-hero.webp`,
  },
  blocks: [
    {
      type: 'imageText',
      paragraphs: [
        'Celiac disease is an often severe autoimmune disorder in which the ingestion of gluten triggers an immune response that damages the lining of the small intestine. The only treatment for celiac disease is a strict gluten-free diet for life.',
        'Square Fare has a gluten-free kitchen. Our chefs hail from Michelin starred restaurants and make meals individually tailored to your specific needs for the price of takeout. Meals are delivered to your home and can be enjoyed after one minute in the microwave.',
        'Delicious food with no planning, no prep, no cooking, no clean up.',
        "To get started, take our quiz to build your nutritional profile. We'd be happy to connect with your doctor or registered dietitian as needed.",
      ],
      image: `${IMG}/condition-testimonial.webp`,
      imageSide: 'right',
    },
    { type: 'heading', text: 'Get support for celiac disease' },
    { type: 'cta', label: 'Get Started', to: '/quiz' },
    {
      type: 'list',
      heading: '✅ Gluten-Free Foods You Can Eat',
      ordered: false,
      items: [
        'Whole Grains (GF-certified): Quinoa, brown rice, millet, buckwheat, gluten-free oats',
        'Proteins: Eggs, fish, poultry, beef, tofu, tempeh, legumes',
        'Dairy: Milk, yogurt, cheese (unless also lactose-sensitive)',
        'Vegetables & Fruits: All fresh produce',
        'Fats & Oils: Olive oil, avocado oil, butter',
        'Baking Alternatives: Almond flour, coconut flour, tapioca starch, GF bread',
      ],
    },
    {
      type: 'list',
      heading: '🚫 Foods to Avoid (Gluten Sources)',
      ordered: false,
      items: [
        'Wheat, barley, rye, triticale',
        'Traditional pasta, bread, pastries, beer',
        'Soy sauce (unless labeled gluten-free)',
        'Breaded or battered items',
        'Oats not labeled gluten-free',
        'Many processed snacks and dressings',
      ],
    },
    { type: 'heading', text: 'Sample Menu' },
    {
      type: 'list',
      heading: 'Day 1',
      ordered: false,
      items: [
        'Breakfast: Greek Yogurt Parfait with Homemade Muesli and Nectarines',
        'Lunch: Metabolic Boost Bowl with Sofrito Chicken',
        'Dinner: Lean Power Bowl with Turkey Meatballs',
        'Snack: Homemade Healthy Trail Mix',
      ],
    },
    {
      type: 'list',
      heading: 'Day 2',
      ordered: false,
      items: [
        'Breakfast: Overnight Oats with Chia Seeds and Fresh Berries',
        'Lunch: Focus Fuel Bowl with Salmon',
        'Dinner: Fiber Strength Bowl with Chickpeas',
        'Snack: Pack of 6 Meyer Lemon Energy Bites',
      ],
    },
    {
      type: 'list',
      heading: 'Day 3',
      ordered: false,
      items: [
        'Breakfast: Morning Energy Bowl',
        'Lunch: Skin Renew Bowl with Cod',
        'Dinner: Gut Harmony Bowl with Sesame-Ginger Tofu',
        'Snack: 1 High Protein Peanut Butter Cup (or the pack of 6 for more indulgent days!)',
      ],
    },
    { type: 'cta', label: 'Book a chat', href: 'https://calendly.com/squarefare' },
    {
      type: 'form',
      formType: 'general',
      heading: 'Get in touch.',
      intro: 'Have questions? We are here to help! Book a chat, send us a message via the form below or call us at 917 679 5306.',
    },
    {
      type: 'quote',
      text: "As a nutritionist, it can be difficult if not seemingly impossible to find meal options for my clients that are convenient, flavorful, diverse, affordable AND that meet the client's nutritional needs. Square Fare checks all the boxes and more, and Claire makes the process of improving health and dietary habits a seamless process for both the client and the practitioner! Recommending Square Fare to health-conscious individuals, athletes, busy working professionals and anyone with a passion for good food is a total no-brainer. Thank you, Claire!",
      name: 'Emma Harvie, Functional Nutritionist at Athleats Nutrition',
    },
    { type: 'heading', text: 'FAQs' },
    {
      type: 'faq',
      items: [
        {
          q: 'Can I speak with a Square Fare registered dietitian partner?',
          a: ['Absolutely! Email Claire with your request: claire@getsquarefare.com.'],
        },
        {
          q: 'Can you accommodate allergies?',
          a: ['Yes, we do this all the time. Just let us know what your dietary constraints are when you take the quiz.'],
        },
        {
          q: 'What meals do you make?',
          a: ['Our meals change weekly, our weekly menu can be accessed here.'],
        },
        {
          q: 'When do you deliver?',
          a: [DELIVERY.line],
        },
        {
          q: 'What are your delivery zones?',
          a: [`We serve ${DELIVERY.zones}.`],
        },
        {
          q: 'How far in advance do I need to place the order?',
          a: [DELIVERY.cutoffLine],
        },
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
